export const widthOptions = { xs: 'XS', sm: 'SM', md: 'MD', lg: 'LG', xl: 'XL', auto: 'AUTO' };
export const rowMinHeightOptions = { none: 'NONE', sm: 'SM', md: 'MD', lg: 'LG', xl: 'XL' };
export const verticalAlignOptions = { center: 'CENTER', top: 'TOP', bottom: 'BOTTOM' };
export const horizontalAlignOptions = { center: 'CENTER', left: 'LEFT', right: 'RIGHT' };
export const sortIndicatorTypes = {
  arrow: 'arrow',
  caret: 'caret',
};
